module.exports = __webpack_public_path__ + "6bdb6c2997d1b54f88a9cd3f6136b946.jpg";